import gql from 'graphql-tag';

const switchesQuery = gql`
  query switchesQuery($accountId: Int!, $withAccount: Boolean!) {
    session {
      identity
      switches
    }

    account(id: $accountId) @include(if: $withAccount) {
      id
      switches
    }
  }
`;

export default switchesQuery;
